<div class="col-sm-12" id="pgmJourFerie" style="height: 100%; padding-top: 5px;">
  <div class="fiche col-sm-12" style="padding: 2px 10px 5px 10px;">
    <div class="text-right col-sm-12 pull-right" style="padding-right: 0;">
      <div class="col-sm-7 fiche-client">
        <div> Définir les périodes d'inactivité </div>
      </div>
      <button class="uppercase" id="savecont" (click)="save()"> Enregistrer </button>
      <button class="uppercase btn-close" id="closeclt" (click)="showFiche()"> Fermer </button>
    </div>
  </div>
  <div class="contente ligneBon col-sm-12"  style="color: #000000;">
    <div class="col-sm-12" style="margin-top: 15px;">
      <div class="col-sm-5" style="padding: 5px;">
        <button class="btn-add" (click)="addLigne()">
          <i class="fa fa-plus"></i>
        </button>
        <span (click)="addLigne()" style="color: #000000;"> Ajouter une periode </span>
      </div>
    </div>
    <div class="col-sm-12 notshowQteSupp" style="padding: 5px; ">
      <ngx-datatable class="material" [rows]="listePeriodesPause" style="height: 100%;" [columnMode]="'force'"
        [headerHeight]="30" [footerHeight]="0" [rowHeight]="'auto'" [selectionType]="'single'"
        [messages]="{emptyMessage: loadingIndicator ? 'Chargement ...' :'Pas de tarification à afficher'}"
        [loadingIndicator]="loadingIndicator">

        <ngx-datatable-column name="quantite" prop="jourFerie.nom">
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Date debut </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-row="row" let-rowIndex="rowIndex" ngx-datatable-cell-template>
            <app-input-date [class]="'form-control'" [id]="'date1'" [model]="row.dateStart" [container]="true"
              (changefct)="row.dateStart = $event;" [placeholder]="'Date debut'" [showDatepicker]="true"></app-input-date>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column>
          <ng-template ngx-datatable-header-template let-allRowsSelected="allRowsSelected" let-selectFn="selectFn"
            let-sort="sortFn">
            <div class="tableheader">
              <span class="uppercase"> Date fin </span>
            </div>
          </ng-template>
          <ng-template let-value="value" let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
            <app-input-date [class]="'form-control'" [id]="'date1'" [model]="row.dateEnd" [container]="true"
              (changefct)="row.dateEnd = $event;" [placeholder]="'Date Fin'" [showDatepicker]="true"></app-input-date>
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column [width]="50">
          <ng-template ngx-datatable-cell-template let-rowIndex="rowIndex" let-row="row">
            <button class="btn-detail pull-right" (click)="deleteLigne(row)">
              <i class="fa fa-trash"></i>
            </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>

  </div>
</div>